"use client"

import { Button } from "@/components/ui/button"

export function ErrorFallback() {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen space-y-4 p-4">
            <h2 className="text-xl font-semibold">مشکلی پیش آمده است!</h2>
            <p className="text-muted-foreground text-center">
                لطفاً صفحه را رفرش کنید یا بعداً دوباره تلاش کنید
            </p>
            <Button
                variant="outline"
                onClick={() => window.location.reload()}
            >
                رفرش صفحه
            </Button>
        </div>
    )
}